import { render, staticRenderFns } from "./ListWidgets.vue?vue&type=template&id=b0c66bd4&"
import script from "./ListWidgets.vue?vue&type=script&lang=ts&"
export * from "./ListWidgets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports